import {
  WEATHER_TYPE,
  WIND_DIRECTION,
  type WeatherType,
  type WindDirection,
} from '../types/weatherForecast';

/**
 * 天気の種類に応じたアイコン名を取得するヘルパー関数
 * @param weatherType 天気の種類
 * @returns Material Symbols アイコン名
 */
export function getWeatherIcon(weatherType: WeatherType): string {
  const WEATHER_ICONS: Record<WeatherType, string> = {
    [WEATHER_TYPE.SUNNY]: 'sunny',
    [WEATHER_TYPE.CLOUDY]: 'cloud',
    [WEATHER_TYPE.RAINY]: 'rainy',
    [WEATHER_TYPE.SNOWY]: 'weather_snowy',
  };
  return WEATHER_ICONS[weatherType];
}

/**
 * 風向に応じた日本語表示を取得するヘルパー関数
 * @param windDirection 風向
 * @returns 風向の日本語ラベル
 */
export function getWindDirectionLabel(windDirection: WindDirection): string {
  const WIND_DIRECTION_LABELS: Record<WindDirection, string> = {
    [WIND_DIRECTION.N]: '北',
    [WIND_DIRECTION.NE]: '北東',
    [WIND_DIRECTION.E]: '東',
    [WIND_DIRECTION.SE]: '南東',
    [WIND_DIRECTION.S]: '南',
    [WIND_DIRECTION.SW]: '南西',
    [WIND_DIRECTION.W]: '西',
    [WIND_DIRECTION.NW]: '北西',
  };
  return WIND_DIRECTION_LABELS[windDirection];
}
